function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 10.085,
  cy: 4.501,
  r: 4.501
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.763,11.48h-1.25V7.814h-2.959V6.896h-1.813c0-0.574-0.483-1.041-1.082-1.041c-0.6,0-1.084,0.467-1.084,1.041h-1.812 v0.918h-3.417v1.87L14.257,9.68h-2.533l-1.717,1.99L8.348,9.68l-3.643,0.492l-0.238,8.276h1.547l0.082,1.68h0.236v1.026v0.755 v8.014h-0.31l-1.807,0.39v1.666h1.537l1.796-0.293l0.017,0.293h1.987v-1.855v-0.2v-8.014h1.133v8.014v0.2v1.855h1.99l0.016-0.293 l1.795,0.293h1.538v-1.666l-1.806-0.391h-0.311v-8.014v-0.756v-1.025h0.286l0.152-2.972v6.991h12.167v-9.292h1.25L27.763,11.48 L27.763,11.48z M20.659,6.517c0.24,0,0.438,0.195,0.438,0.438s-0.195,0.438-0.438,0.438S20.22,7.198,20.22,6.955 S20.417,6.517,20.659,6.517z M25.513,23.146H15.346V8.814h2.417v0.708h5.791V8.814h1.959v2.666h-0.792v3.375h0.792V23.146z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgPlanMy = function SvgPlanMy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "31.979px",
    height: "31.979px",
    viewBox: "0 0 31.979 31.979",
    style: {
      enableBackground: "new 0 0 31.979 31.979"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlanMy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/planMy.7ff56add.svg";
export { ForwardRef as ReactComponent };